import React from 'react';
import { motion } from 'framer-motion';
import { developmentAreas } from '../data/developmentAreas';
export function DevelopmentAreas() {
  return <section className="py-24 px-6 md:px-10 bg-white" data-id="element-34" data-mp="34555s3o8ar40">
      <div className="max-w-7xl mx-auto" data-id="element-35" data-mp="38xg9lhm3ax1u">
        <div className="max-w-3xl mb-16" data-id="element-36" data-mp="38yht8ah68rv6">
          <p className="text-[#C5A55A] text-xs tracking-[0.3em] uppercase mb-4" data-id="element-37" data-mp="3dxazpiy1jilu">
            What we develop
          </p>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-black mb-6" data-id="element-38" data-mp="2ga2ja2cwczqp">
            Four ways we take a property forward
          </h2>
          <div className="w-16 h-[2px] bg-[#C5A55A]" data-id="element-39" data-mp="2l9ymhzdrsn57" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-14" data-id="element-40" data-mp="2q5nhrqirbhvp">
          {developmentAreas.map((area, index) => <motion.article key={area.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col border-t border-gray-200 pt-8" data-id="element-41" data-mp="2u6h62l042yp4" data-mpi={index}>
              <div className="flex items-baseline gap-4 mb-4" data-id="element-42" data-mp="1kd2e8jqbqtia">
                <span className="text-[#C5A55A] font-serif text-2xl" data-id="element-43" data-mp="1gd1z0wveiea6">
                  0{index + 1}
                </span>
                <h3 className="text-2xl md:text-3xl font-serif font-bold text-black" data-id="element-44" data-mp="1beqr4roo2dul">
                  {area.title}
                </h3>
              </div>
              <p className="text-lg text-black font-medium mb-3" data-id="element-45" data-mp="16l5sqyj5vhuv">
                {area.summary}
              </p>
              <p className="text-gray-600 leading-relaxed" data-id="element-46" data-mp="wp2qlsob7j7x">
                {area.description}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}